import React from 'react';
import './Footer.less';

const Footer: React.FC = () => {
  return (
    <div className="Footer-text">
      IDEXX {new Date().getFullYear()} @ All rights reserved.
    </div>
  );
};

export default Footer;
